import React, { useCallback } from 'react';
import TimerOutlined from '@mui/icons-material/TimerOutlined';
import SliderButton from '../utils/SliderButton';
import './GenTimer.css';

const TIME_UNIT = 's';
const TXT_TIME_LIMIT = { fr: 'Durée', en: 'Duration', de: 'Dauer', es: 'Duración', pt: 'Duração' };

const GenTimer = ({
    value,
    onChange,
    min,
    max,
    step,
    steps = null,
    disabled = false,
    lang = 'fr',
    showIcon = true,
    className = '',
}) => {
    const label = TXT_TIME_LIMIT[lang] || TXT_TIME_LIMIT.en;

    // Natural wall-ish stops (1 2 3 4 5 7 10…); API peels overhead separately.
    const useSteps = Array.isArray(steps) && steps.length > 1;
    const sliderValue = useSteps
        ? Math.max(0, steps.findIndex((s) => s >= value))
        : value;

    const handleChange = useCallback(
        (newValue) => {
            if (disabled) return;
            if (useSteps) {
                const i = Math.max(0, Math.min(steps.length - 1, Math.round(newValue)));
                onChange(steps[i]);
                return;
            }
            const safe = Number.isFinite(newValue) ? newValue : min;
            onChange(Math.max(min, Math.min(max, safe)));
        },
        [onChange, disabled, min, max, useSteps, steps]
    );

    return (
        <SliderButton
            value={sliderValue}
            onChange={handleChange}
            min={useSteps ? 0 : min}
            max={useSteps ? steps.length - 1 : max}
            step={useSteps ? 1 : step}
            disabled={disabled}
            label={label}
            visualMin={0}
            className={`gen-timer${className ? ` ${className}` : ''}`}
        >
            {showIcon ? (
                <TimerOutlined className="gen-timer__icon" fontSize="small" />
            ) : null}
            <span className="gen-timer__value">
                {value}
                {TIME_UNIT}
            </span>
        </SliderButton>
    );
};

export const GenTimerSheetRow = ({
    lang = 'fr',
    children,
    disabled = false,
}) => {
    const label = TXT_TIME_LIMIT[lang] || TXT_TIME_LIMIT.en;

    return (
        <div className={`gen-timer-sheet-row row${disabled ? ' gen-timer-sheet-row--disabled' : ''}`}>
            <span className="mobile-sheet-list__icon-slot">
                <TimerOutlined className="gen-timer-sheet-row__icon" fontSize="small" />
            </span>
            <span className="gen-timer-sheet-row__label">
                <span>{label}</span>
            </span>
            <div className="gen-timer-sheet-row__control">
                {children}
            </div>
        </div>
    );
};

export default GenTimer;
